module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD2SURBVHgBxZG/agJBEId/s5twSRGIuSNlEkjKdL5EAil8BUkR0lhbGkiI1/mnsRB3fQSxsfAR7EVsfACtbCxkx/GEE1HBs9APZneW4dvZZYCz0EtfEo5AGf8f4DeFhIhoZctL1jrcMk9XIhYlWDX8MpIgUikSzV0hibcWbRBuFLTxM6jfPu4Xg9pOUSCywZAY2jm843M8iCvLP/I0BCEnp9BlJ/mti1njg8Ge0q6DZuohLmBaWIn8s0uMOkdrPfVKWrVJnuD0RUbN3bdIX2D8Orr5Q3Y02y8vsUFaMXclu5bwJKrSMYeDsffPZPx+4nHEVF48nIIFqh1L0FrzPQoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/basic/tick.png
// module id = QX66
// module chunks = 1